var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasksNewEntry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#00dbd5;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tasks_new_entry"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 299.84,
    cy: 300.36,
    r: 299.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M441.69,244.08h-90V159.17a56,56,0,0,0-55.85-55.85h0A56,56,0,0,0,240,159.17v84.91H160.09a56,56,0,0,0-55.85,55.85h0a56,56,0,0,0,55.85,55.85H240v85a56,56,0,0,0,55.85,55.85h0a56,56,0,0,0,55.85-55.85v-85h90a56,56,0,0,0,55.85-55.85h0A56,56,0,0,0,441.69,244.08Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasksNewEntry);
export default __webpack_public_path__ + "static/media/tasks_new_entry.dd2b250eea336a807727b4604c425cdd.svg";
export { ForwardRef as ReactComponent };